import { render } from "./thisOrThatOne.vue?vue&type=template&id=34bcb9e3"
import script from "./thisOrThatOne.vue?vue&type=script&lang=js"
export * from "./thisOrThatOne.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__